module.exports = __webpack_public_path__ + "static/media/room-1.8d0b6047.jpeg";